import React from 'react';
import { motion } from 'framer-motion';
import { Users, Twitter, Linkedin, ArrowRight } from 'lucide-react';
import { EXTERNAL_LINKS } from '../config';
import { useLanguage } from './LanguageContext';

const teamMembers = [
  {
    name: "Garrison",
    role: "about.roleRober",
    image: "/images/team/garrison.png",
    twitter: "https://twitter.com/NFT_Garrison",
    linkedin: "https://www.linkedin.com/in/originalgarrison/",
    description: "about.roberDesc"
  },
  {
    name: "Martín Olalla",
    role: "about.roleMartin",
    image: "/images/team/martin.png",
    twitter: "https://x.com/martin_olalla",
    linkedin: "https://linkedin.com/in/martinolallabonal",
    description: "about.martinDesc"
  },
  {
    name: "Pedro Tornero",
    role: "about.rolePedro",
    image: "/images/team/pedro.png",
    twitter: "https://twitter.com/Pemacla1",
    linkedin: "https://www.linkedin.com/in/pedro-tornero-b38371299/",
    description: "about.pedroDesc"
  },
  {
    name: "Sergio Olmo",
    role: "about.roleSergio",
    image: "/images/team/sergio.png",
    twitter: "https://twitter.com/Fiveat",
    linkedin: "https://www.linkedin.com/in/solmo/",
    description: "about.sergioDesc"
  },
  {
    name: "Beanie",
    role: "about.roleBeanie",
    image: "/images/team/beanie.png",
    twitter: "https://twitter.com/Beanie_NFT23",
    description: "about.beanieDesc"
  }
];

const TeamSphere = ({ member, index, t }) => (
  <motion.div
    className="team-sphere-container"
    initial={{ opacity: 0, scale: 0 }}
    whileInView={{ opacity: 1, scale: 1 }}
    transition={{ 
      duration: 0.35, 
      delay: index * 0.1,
      type: "spring",
      stiffness: 200
    }}
    viewport={{ once: true, amount: 0.1 }}
  >
    <div className="team-sphere">
      <div className="team-sphere-front">
        {member.image ? (
          <img 
            src={member.image} 
            alt={member.name} 
            className="team-sphere-img"
          />
        ) : (
          <span className="team-sphere-emoji">{member.avatar}</span>
        )}
        <span className="team-sphere-name">{member.name}</span>
      </div>
      
      <div className="team-sphere-back">
        <span className="team-sphere-role">{t(member.role)}</span>
        <p className="team-sphere-desc">{t(member.description)}</p>
        <div className="team-sphere-socials">
          {member.twitter && (
            <a 
              href={member.twitter} 
              target="_blank" 
              rel="noopener noreferrer"
              className="team-sphere-social"
              aria-label={`${member.name} Twitter`}
              onClick={(e) => e.stopPropagation()}
            >
              <Twitter size={14} />
            </a>
          )}
          {member.linkedin && (
            <a 
              href={member.linkedin} 
              target="_blank" 
              rel="noopener noreferrer"
              className="team-sphere-social"
              aria-label={`${member.name} LinkedIn`}
              onClick={(e) => e.stopPropagation()}
            >
              <Linkedin size={14} />
            </a>
          )}
        </div>
      </div>
    </div>
  </motion.div>
);

const WhataTeam = () => {
  const { t, language } = useLanguage();
  const isEN = language === 'en';

  return (
    <motion.div 
      className="about-team" id="team"
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, delay: 0.4 }}
      viewport={{ once: true, amount: 0.1 }}
    >
      {/* Header — mismo patrón que ProcessSteps */}
      <div className="ps-header ps-header--center">
        <div className="ps-eyebrow">
          <span className="ps-eyebrow-dot" />
          {isEN ? 'the team' : 'el equipo'}
        </div>
        <div className="ps-header-row">
          <h2 className="ps-title">
            {isEN
              ? <><span className="ps-title-accent">WhataTeam.</span><br />The minds behind.</>
              : <><span className="ps-title-accent">WhataTeam.</span><br />Las mentes detrás.</>
            }
          </h2>
        </div>
      </div>

      <div className="team-spheres">
        {teamMembers.map((member, index) => (
          <TeamSphere 
            key={member.name} 
            member={member} 
            index={index} 
            t={t} 
          />
        ))}
      </div>
    </motion.div>
  );
};

export default WhataTeam;
